var _path, _rect, _rect2, _path2, _path3, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelayDiscounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 18H70V18C70 18 56 38 56 50C56 62 70 82 70 82V82H30V82C30 82 44 62 44 50C44 38 30 18 30 18Z",
    fill: "#FAC1B5",
    stroke: "#C75E5A",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 14,
    width: 48,
    height: 6,
    rx: 3,
    fill: "#C75E5A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 80,
    width: 48,
    height: 6,
    rx: 3,
    fill: "#C75E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24C38 24 44 38 44 44H56C56 38 62 24 62 24H38Z",
    fill: "#F9907B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 56C44 62 36 74 34 76H66C64 74 56 62 56 56H44Z",
    fill: "#F9907B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 7,
    fill: "#C75E5A"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 54,
    fontFamily: "sans-serif",
    fontSize: 9,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "$")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayDiscounting);
export default __webpack_public_path__ + "static/media/DelayDiscounting.a6623246199f3c328792778bc25607a4.svg";
export { ForwardRef as ReactComponent };